import request from '@/utils/sap-request'


/**
 * 现金奖励项目查询
 * @param {*} params
 */
export function getCashReward(data) {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/get_cash_reward',
    method: 'post',
    data
  })
}
// 现金奖励项目处理
export function cashReward(data) {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/cash_reward',
    method: 'post',
    data
  })
}
/**
 * 客户奖励查询
 * @param {*} params
 */
export function getBpReward(data) {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/get_bp_reward',
    method: 'post',
    data
  })
}
// 客户奖励处理
export function bpReward(data) {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/bp_reward',
    method: 'post',
    data
  })
}
/**
 * 奖励明细报表
 * @param {*} params
 */
export function rewardReport(data) {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/reward_report',
    method: 'post',
    data
  })
}
// 剩余奖励查询
export function getRemReward(data) {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/get_rem_reward',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/sap/reward-policy.js